/**
 * Created by maximus on 16.12.16.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addToWishList = addToWishList;
exports.delFromWishList = delFromWishList;
exports.wishListFromLocalStorage = wishListFromLocalStorage;
exports.wishListUpdateProduct = wishListUpdateProduct;
exports.getActualPricesWishList = getActualPricesWishList;
exports.setWishList = setWishList;

var _constants = require('redux/constants');

function addToWishList(product) {
    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return {
        type: _constants.WishConstants.ADD_TO_WISHLIST,
        product: product,
        user_id: user_id
    };
}

function delFromWishList(product) {
    var user_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return {
        type: _constants.WishConstants.DEL_FROM_WISHLIST,
        product: product,
        user_id: user_id
    };
}

function wishListFromLocalStorage() {
    return {
        type: _constants.WishConstants.COPY_TO_WISHLIST
    };
}

function wishListUpdateProduct() {
    return {
        type: _constants.WishConstants.UPDATE_PRODUCT_FOR_WISHLIST
    };
}

function getActualPricesWishList() {
    var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return {
        types: [_constants.WishConstants.GET_ACTUAL_PRICES_LOAD_WISHLIST, _constants.WishConstants.GET_ACTUAL_PRICES_SUCCESS_WISHLIST, _constants.WishConstants.GET_ACTUAL_PRICES_FAIL_WISHLIST],
        promise: function promise(client, iBonus) {
            return iBonus.getActualPrices(basketElements);
        }
    };
}

function setWishList(wishList) {
    return {
        types: [_constants.WishConstants.SET_WISHLIST, _constants.WishConstants.SET_WISHLIST_SUCCESS, _constants.WishConstants.SET_WISHLIST_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.setWishList(wishList);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/wish_list.js
// module id = 166
// module chunks = 0